// // src/components/DirectMessage.tsx
// import React, { useState, useEffect } from 'react';
// import { usePermissionGuard } from '../hooks/usePermissionGuard';
// import { Popup } from './Popup';
// import { getAllUsers } from '../api/user';
// import { useUserInfo } from '../hooks/useUserInfo';

// interface DirectMessageModalProps {
//   isOpen: boolean;
//   onClose: () => void;
// }

// interface Employee {
//   id: string;
//   user_id: string;
//   name: string;
//   email: string;
//   role: string;
//   phone?: string;
// }

// export function DirectMessageModal({ isOpen, onClose }: DirectMessageModalProps) {
//   const [channel, setChannel] = useState<'email' | 'sms'>('email');
//   const [selectedEmployee, setSelectedEmployee] = useState<string>('');
//   const [message, setMessage] = useState('');
//   const [sending, setSending] = useState(false);
//   const [employees, setEmployees] = useState<Employee[]>([]);
//   const [loadingEmployees, setLoadingEmployees] = useState(false);
//   const { showError, showSuccess, popup, closePopup } = usePermissionGuard();
//   const { getUserName, getUserEmail } = useUserInfo();

//   useEffect(() => {
//     if (isOpen) {
//       fetchEmployees();
//     }
//   }, [isOpen]);

//   const fetchEmployees = async () => {
//     setLoadingEmployees(true);
//     try {
//       const response = await getAllUsers();
//       const users = response.users || [];
//       setEmployees(users.map((user: any) => ({
//         id: user.id,
//         user_id: user.user_id,
//         name: user.name || `${user.first_name} ${user.last_name}`.trim(),
//         email: user.email,
//         role: user.role,
//         phone: user.phone || '',
//       })));
//     } catch (error) {
//       console.error('Failed to fetch employees:', error);
//     } finally {
//       setLoadingEmployees(false);
//     }
//   };

//   const getChannelConfig = () => {
//     switch (channel) {
//       case 'email':
//         return { color: '#4F46E5', bg: 'from-blue-500 to-indigo-600', icon: '📧', label: 'Email' };
//       case 'sms':
//         return { color: '#0891B2', bg: 'from-cyan-500 to-blue-600', icon: '📱', label: 'SMS' };
//       default:
//         return { color: '#4F46E5', bg: 'from-blue-500 to-indigo-600', icon: '📧', label: 'Email' };
//     }
//   };

//   const getRecipientContact = () => {
//     const employee = employees.find(e => e.id === selectedEmployee);
//     if (!employee) return '';
//     if (channel === 'email') return employee.email;
//     if (channel === 'sms') return employee.phone || employee.email;
//     return '';
//   };

//   const handleSend = async () => {
//     if (!selectedEmployee) {
//       showError('NO_RECIPIENT', 'Please select a recipient');
//       return;
//     }
//     if (!message.trim()) {
//       showError('NO_MESSAGE', 'Please enter a message');
//       return;
//     }

//     setSending(true);
//     try {
//       await new Promise(resolve => setTimeout(resolve, 1500));
      
//       const recipient = employees.find(e => e.id === selectedEmployee);
//       showSuccess('Message Sent', `Your ${channel.toUpperCase()} message has been sent to ${recipient?.name}`);
//       setMessage('');
//       setSelectedEmployee('');
//       setTimeout(() => onClose(), 1500);
//     } catch (error: any) {
//       showError('SEND_FAILED', error.message || 'Failed to send message');
//     } finally {
//       setSending(false);
//     }
//   };

//   const getMessagePlaceholder = () => {
//     switch (channel) {
//       case 'email':
//         return 'Type your email message here...';
//       case 'sms':
//         return 'Type your SMS message here...';
//       default:
//         return 'Type your message here...';
//     }
//   };

//   if (!isOpen) return null;

//   const channelConfig = getChannelConfig();
//   const recipient = employees.find(e => e.id === selectedEmployee);

//   return (
//     <>
//       {/* Backdrop */}
//       <div 
//         className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 transition-opacity duration-300"
//         onClick={onClose}
//       />

//       {/* Modal - Responsive */}
//       <div className="fixed inset-0 z-50 overflow-y-auto">
//         <div className="flex min-h-full items-center justify-center p-3 sm:p-4">
//           <div 
//             className="relative bg-white rounded-2xl shadow-2xl w-full max-w-[95%] sm:max-w-lg md:max-w-xl max-h-[95vh] sm:max-h-[90vh] overflow-hidden animate-in fade-in zoom-in duration-300"
//             onClick={(e) => e.stopPropagation()}
//           >
//             {/* Header - Responsive */}
//             <div className="sticky top-0 bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-200 px-4 sm:px-6 py-4 sm:py-5">
//               <div className="flex justify-between items-center">
//                 <div className="flex items-center gap-2 sm:gap-3">
//                   <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center shadow-md">
//                     <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
//                     </svg>
//                   </div>
//                   <div>
//                     <h2 className="text-lg sm:text-xl font-bold text-gray-900">Send Direct Message</h2>
//                     <p className="text-xs sm:text-sm text-gray-500 mt-0.5">Send instant message to team members</p>
//                   </div>
//                 </div>
//                 <button
//                   onClick={onClose}
//                   className="p-1.5 sm:p-2 hover:bg-gray-100 rounded-lg transition-colors"
//                 >
//                   <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                   </svg>
//                 </button>
//               </div>
//             </div>

//             {/* Form Body - Responsive scrolling */}
//             <div className="overflow-y-auto max-h-[calc(95vh-120px)] sm:max-h-[calc(90vh-130px)] p-4 sm:p-6">
//               {/* Send Via Options - Only Email and SMS */}
//               <div className="mb-5 sm:mb-6">
//                 <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2 sm:mb-3">
//                   SEND VIA
//                 </label>
//                 <div className="grid grid-cols-2 gap-2 sm:gap-3">
//                   <button
//                     onClick={() => setChannel('email')}
//                     className={`flex items-center justify-center gap-1 sm:gap-2 px-2 sm:px-4 py-2 sm:py-3 rounded-xl font-medium transition-all duration-200 text-xs sm:text-sm ${
//                       channel === 'email'
//                         ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-md transform scale-105'
//                         : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//                     }`}
//                   >
//                     <span className="text-base sm:text-lg">📧</span>
//                     <span>Email</span>
//                   </button>
//                   <button
//                     onClick={() => setChannel('sms')}
//                     className={`flex items-center justify-center gap-1 sm:gap-2 px-2 sm:px-4 py-2 sm:py-3 rounded-xl font-medium transition-all duration-200 text-xs sm:text-sm ${
//                       channel === 'sms'
//                         ? 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white shadow-md transform scale-105'
//                         : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//                     }`}
//                   >
//                     <span className="text-base sm:text-lg">📱</span>
//                     <span>SMS</span>
//                   </button>
//                 </div>
//               </div>

//               {/* Select Employee - Responsive */}
//               <div className="mb-5">
//                 <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
//                   TO <span className="text-red-500">*</span>
//                 </label>
//                 <div className="relative">
//                   <select
//                     value={selectedEmployee}
//                     onChange={(e) => setSelectedEmployee(e.target.value)}
//                     className="w-full px-3 sm:px-4 py-2 sm:py-2.5 text-sm border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors appearance-none bg-white"
//                   >
//                     <option value="">-- Select Employee --</option>
//                     {employees.map(emp => (
//                       <option key={emp.id} value={emp.id}>
//                         {emp.name} ({emp.role})
//                       </option>
//                     ))}
//                   </select>
//                   <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
//                     <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//                     </svg>
//                   </div>
//                 </div>
                
//                 {/* Selected Employee Info - Responsive */}
//                 {selectedEmployee && recipient && (
//                   <div className="mt-3 p-3 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
//                     <div className="flex items-center gap-2 sm:gap-3">
//                       <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-blue-400 to-blue-500 rounded-full flex items-center justify-center text-white font-bold text-sm sm:text-base">
//                         {recipient.name.charAt(0).toUpperCase()}
//                       </div>
//                       <div className="flex-1 min-w-0">
//                         <p className="font-medium text-gray-900 text-sm sm:text-base truncate">{recipient.name}</p>
//                         <p className="text-xs text-gray-500">{recipient.role}</p>
//                         <p className="text-xs text-gray-400 mt-1 truncate">
//                           {channel === 'email' ? `📧 ${recipient.email}` : `📱 ${recipient.phone || recipient.email}`}
//                         </p>
//                       </div>
//                       <div className={`px-2 sm:px-3 py-1 rounded-full text-xs font-medium text-white bg-gradient-to-r ${channelConfig.bg} whitespace-nowrap`}>
//                         {channelConfig.label}
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>

//               {/* Message - Responsive */}
//               <div className="mb-5">
//                 <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
//                   MESSAGE <span className="text-red-500">*</span>
//                 </label>
//                 <textarea
//                   value={message}
//                   onChange={(e) => setMessage(e.target.value)}
//                   rows={4}
//                   placeholder={getMessagePlaceholder()}
//                   className="w-full px-3 sm:px-4 py-2 sm:py-3 text-sm border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
//                 />
//                 <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 mt-2">
//                   <p className="text-xs text-gray-400">
//                     {message.length} characters
//                   </p>
//                   <div className="flex flex-wrap gap-2">
//                     {[
//                       "Task Reminder",
//                       "Approval Needed", 
//                       "Correction Required",
//                       "Great Work"
//                     ].map((template, idx) => (
//                       <button
//                         key={idx}
//                         type="button"
//                         onClick={() => setMessage(template + ": Please check the HRM portal for task details.")}
//                         className="text-xs text-blue-600 hover:text-blue-700 underline whitespace-nowrap"
//                       >
//                         {template}
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               {/* Info Box - Responsive */}
//               <div className="mb-5 p-3 bg-amber-50 border border-amber-200 rounded-xl">
//                 <div className="flex items-start gap-2">
//                   <svg className="w-3 h-3 sm:w-4 sm:h-4 text-amber-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                   </svg>
//                   <p className="text-xs text-amber-700">
//                     Message will be sent via {channelConfig.label}. Make sure the recipient has provided contact details.
//                   </p>
//                 </div>
//               </div>

//               {/* Form Actions - Responsive */}
//               <div className="flex justify-end gap-3 pt-2">
//                 <button
//                   type="button"
//                   onClick={onClose}
//                   className="px-3 sm:px-5 py-2 sm:py-2.5 text-sm border border-gray-300 rounded-xl text-gray-700 hover:bg-gray-50 transition-colors font-medium"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleSend}
//                   disabled={sending || !selectedEmployee || !message.trim()}
//                   className={`px-4 sm:px-6 py-2 sm:py-2.5 text-sm bg-gradient-to-r ${channelConfig.bg} text-white rounded-xl hover:from-${channelConfig.bg.split(' ')[1].replace('to-', '')} hover:to-${channelConfig.bg.split(' ')[2]} transition-all disabled:opacity-50 disabled:cursor-not-allowed font-medium flex items-center gap-2 shadow-md`}
//                 >
//                   {sending ? (
//                     <>
//                       <svg className="animate-spin h-3 w-3 sm:h-4 sm:w-4 text-white" fill="none" viewBox="0 0 24 24">
//                         <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                         <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                       </svg>
//                       <span className="hidden xs:inline">Sending...</span>
//                       <span className="xs:hidden">...</span>
//                     </>
//                   ) : (
//                     <>
//                       <span className="text-sm sm:text-base">{channelConfig.icon}</span>
//                       <span className="hidden xs:inline">Send {channelConfig.label}</span>
//                       <span className="xs:hidden">Send</span>
//                     </>
//                   )}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <Popup
//         isOpen={popup.isOpen}
//         type={popup.type}
//         title={popup.title}
//         message={popup.message}
//         onClose={closePopup}
//       />

//       <style>{`
//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }
//         @keyframes zoomIn {
//           from { transform: scale(0.95); opacity: 0; }
//           to { transform: scale(1); opacity: 1; }
//         }
//         .animate-in {
//           animation-duration: 0.2s;
//           animation-fill-mode: both;
//         }
//         .fade-in {
//           animation-name: fadeIn;
//         }
//         .zoom-in {
//           animation-name: zoomIn;
//         }
        
//         /* Custom breakpoint for extra small screens */
//         @media (max-width: 480px) {
//           .xs\\:inline {
//             display: inline;
//           }
//           .xs\\:hidden {
//             display: none;
//           }
//         }
//         @media (min-width: 481px) {
//           .xs\\:inline {
//             display: inline;
//           }
//           .xs\\:hidden {
//             display: inline;
//           }
//         }
//       `}</style>
//     </>
//   );
// }

// src/components/DirectMessage.tsx
import React, { useState, useEffect } from 'react';
import { usePermissionGuard } from '../hooks/usePermissionGuard';
import { Popup } from './Popup';
import { getAllUsers, sendDirectMail, User, DirectMailPayload } from '../api/user';
import { useUserInfo } from '../hooks/useUserInfo';

interface DirectMessageModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function DirectMessageModal({ isOpen, onClose }: DirectMessageModalProps) {
  const [channel, setChannel] = useState<'email' | 'sms'>('email');
  const [selectedEmployee, setSelectedEmployee] = useState<string>('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [employees, setEmployees] = useState<User[]>([]);
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const { showError, showSuccess, popup, closePopup } = usePermissionGuard();
  const { getUserName, getUserEmail } = useUserInfo();

  useEffect(() => {
    if (isOpen) {
      fetchEmployees();
      // Reset form when modal opens
      setSelectedEmployee('');
      setSubject('');
      setMessage('');
      setChannel('email');
    }
  }, [isOpen]);

  const fetchEmployees = async () => {
    setLoadingEmployees(true);
    try {
      const response = await getAllUsers();
      const users = response.users || [];
      setEmployees(users.map((user: any) => ({
        id: user.id,
        user_id: user.user_id,
        name: user.name || `${user.first_name || ''} ${user.last_name || ''}`.trim(),
        email: user.email,
        role: user.role,
        phone: user.phone || '',
        department: user.department,
        employee_id: user.employee_id,
      })));
    } catch (error) {
      console.error('Failed to fetch employees:', error);
      showError('FETCH_FAILED', 'Failed to load employees list');
    } finally {
      setLoadingEmployees(false);
    }
  };

  const getChannelConfig = () => {
    switch (channel) {
      case 'email':
        return { color: '#4F46E5', bg: 'from-blue-500 to-indigo-600', icon: '📧', label: 'Email' };
      case 'sms':
        return { color: '#0891B2', bg: 'from-cyan-500 to-blue-600', icon: '📱', label: 'SMS' };
      default:
        return { color: '#4F46E5', bg: 'from-blue-500 to-indigo-600', icon: '📧', label: 'Email' };
    }
  };

  const getRecipientContact = () => {
    const employee = employees.find(e => e.id === selectedEmployee);
    if (!employee) return '';
    if (channel === 'email') return employee.email;
    if (channel === 'sms') return employee.phone || employee.email;
    return '';
  };

  const handleSend = async () => {
    if (!selectedEmployee) {
      showError('NO_RECIPIENT', 'Please select a recipient');
      return;
    }
    
    if (channel === 'email' && !subject.trim()) {
      showError('NO_SUBJECT', 'Please enter a subject for the email');
      return;
    }
    
    if (!message.trim()) {
      showError('NO_MESSAGE', 'Please enter a message');
      return;
    }

    const recipient = employees.find(e => e.id === selectedEmployee);
    if (!recipient) {
      showError('INVALID_RECIPIENT', 'Selected recipient not found');
      return;
    }

    setSending(true);
    try {
      // Prepare payload based on channel
      const payload: DirectMailPayload = {
        subject: channel === 'email' ? subject : `[SMS] Task Update`,
        message: message,
      };
      
      // Add recipient identifier (use whichever is available)
      if (recipient.employee_id) {
        payload.employee_id = recipient.employee_id;
      }
      if (recipient.user_id) {
        payload.user_id = recipient.user_id;
      }
      if (recipient.email) {
        payload.email = recipient.email;
      }
      
      // Call the actual API
      const response = await sendDirectMail(payload);
      
      if (response.success) {
        showSuccess(
          'Message Sent', 
          `Your ${channel.toUpperCase()} message has been sent to ${recipient.name}`
        );
        // Reset form
        setMessage('');
        setSubject('');
        setSelectedEmployee('');
        // Close modal after delay
        setTimeout(() => onClose(), 1500);
      } else {
        showError('SEND_FAILED', response.message || 'Failed to send message');
      }
    } catch (error: any) {
      console.error('Send message error:', error);
      showError('SEND_FAILED', error.message || 'Failed to send message. Please try again.');
    } finally {
      setSending(false);
    }
  };

  const getMessagePlaceholder = () => {
    switch (channel) {
      case 'email':
        return 'Type your email message here...';
      case 'sms':
        return 'Type your SMS message here... (160 characters max)';
      default:
        return 'Type your message here...';
    }
  };

  const getSubjectPlaceholder = () => {
    return 'Enter email subject...';
  };

  if (!isOpen) return null;

  const channelConfig = getChannelConfig();
  const recipient = employees.find(e => e.id === selectedEmployee);

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 transition-opacity duration-300"
        onClick={onClose}
      />

      {/* Modal - Responsive */}
      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-3 sm:p-4">
          <div 
            className="relative bg-white rounded-2xl shadow-2xl w-full max-w-[95%] sm:max-w-lg md:max-w-xl max-h-[95vh] sm:max-h-[90vh] overflow-hidden animate-in fade-in zoom-in duration-300"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header - Responsive */}
            <div className="sticky top-0 bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-200 px-4 sm:px-6 py-4 sm:py-5">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-2 sm:gap-3">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center shadow-md">
                    <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                    </svg>
                  </div>
                  <div>
                    <h2 className="text-lg sm:text-xl font-bold text-gray-900">Send Direct Message</h2>
                    <p className="text-xs sm:text-sm text-gray-500 mt-0.5">Send instant message to team members</p>
                  </div>
                </div>
                <button
                  onClick={onClose}
                  className="p-1.5 sm:p-2 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Form Body - Responsive scrolling */}
            <div className="overflow-y-auto max-h-[calc(95vh-120px)] sm:max-h-[calc(90vh-130px)] p-4 sm:p-6">
              {/* Send Via Options - Only Email and SMS */}
              <div className="mb-5 sm:mb-6">
                <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2 sm:mb-3">
                  SEND VIA
                </label>
                <div className="grid grid-cols-2 gap-2 sm:gap-3">
                  <button
                    type="button"
                    onClick={() => {
                      setChannel('email');
                      setSubject('');
                    }}
                    className={`flex items-center justify-center gap-1 sm:gap-2 px-2 sm:px-4 py-2 sm:py-3 rounded-xl font-medium transition-all duration-200 text-xs sm:text-sm ${
                      channel === 'email'
                        ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-md transform scale-105'
                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                    }`}
                  >
                    <span className="text-base sm:text-lg">📧</span>
                    <span>Email</span>
                  </button>
                  <button
                    type="button"
                    onClick={() => setChannel('sms')}
                    className={`flex items-center justify-center gap-1 sm:gap-2 px-2 sm:px-4 py-2 sm:py-3 rounded-xl font-medium transition-all duration-200 text-xs sm:text-sm ${
                      channel === 'sms'
                        ? 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white shadow-md transform scale-105'
                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                    }`}
                  >
                    <span className="text-base sm:text-lg">📱</span>
                    <span>SMS</span>
                  </button>
                </div>
              </div>

              {/* Select Employee - Responsive */}
              <div className="mb-5">
                <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                  TO <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <select
                    value={selectedEmployee}
                    onChange={(e) => setSelectedEmployee(e.target.value)}
                    className="w-full px-3 sm:px-4 py-2 sm:py-2.5 text-sm border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors appearance-none bg-white"
                    disabled={loadingEmployees}
                  >
                    <option value="">-- Select Employee --</option>
                    {loadingEmployees ? (
                      <option disabled>Loading employees...</option>
                    ) : (
                      employees.map(emp => (
                        <option key={emp.id} value={emp.id}>
                          {emp.name} ({emp.role}) {emp.department ? `- ${emp.department}` : ''}
                        </option>
                      ))
                    )}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </div>
                
                {/* Selected Employee Info - Responsive */}
                {selectedEmployee && recipient && (
                  <div className="mt-3 p-3 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
                    <div className="flex items-center gap-2 sm:gap-3">
                      <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-blue-400 to-blue-500 rounded-full flex items-center justify-center text-white font-bold text-sm sm:text-base">
                        {recipient.name.charAt(0).toUpperCase()}
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="font-medium text-gray-900 text-sm sm:text-base truncate">{recipient.name}</p>
                        <p className="text-xs text-gray-500">{recipient.role}</p>
                        <p className="text-xs text-gray-400 mt-1 truncate">
                          {channel === 'email' ? `📧 ${recipient.email}` : `📱 ${recipient.phone || recipient.email}`}
                        </p>
                      </div>
                      <div className={`px-2 sm:px-3 py-1 rounded-full text-xs font-medium text-white bg-gradient-to-r ${channelConfig.bg} whitespace-nowrap`}>
                        {channelConfig.label}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Subject - Only for Email */}
              {channel === 'email' && (
                <div className="mb-5">
                  <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                    SUBJECT <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    placeholder={getSubjectPlaceholder()}
                    className="w-full px-3 sm:px-4 py-2 sm:py-2.5 text-sm border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  />
                  <p className="text-xs text-gray-400 mt-1">
                    {subject.length} characters
                  </p>
                </div>
              )}

              {/* Message - Responsive */}
              <div className="mb-5">
                <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">
                  MESSAGE <span className="text-red-500">*</span>
                </label>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  rows={4}
                  maxLength={channel === 'sms' ? 160 : undefined}
                  placeholder={getMessagePlaceholder()}
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 text-sm border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                />
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 mt-2">
                  <p className="text-xs text-gray-400">
                    {message.length} {channel === 'sms' && `/ 160 characters`}
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {[
                      "Task Reminder",
                      "Approval Needed", 
                      "Correction Required",
                      "Great Work"
                    ].map((template, idx) => (
                      <button
                        key={idx}
                        type="button"
                        onClick={() => {
                          if (channel === 'email') {
                            setMessage(template + ": Please check the HRM portal for task details.");
                          } else {
                            setMessage(template + ": Please check HRM portal.");
                          }
                        }}
                        className="text-xs text-blue-600 hover:text-blue-700 underline whitespace-nowrap"
                      >
                        {template}
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              {/* Info Box - Responsive */}
              <div className="mb-5 p-3 bg-amber-50 border border-amber-200 rounded-xl">
                <div className="flex items-start gap-2">
                  <svg className="w-3 h-3 sm:w-4 sm:h-4 text-amber-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <p className="text-xs text-amber-700">
                    {channel === 'email' 
                      ? 'Message will be sent via Email. Make sure the recipient has a valid email address.'
                      : 'Message will be sent via SMS. Standard SMS rates may apply. Maximum 160 characters.'}
                  </p>
                </div>
              </div>

              {/* Form Actions - Responsive */}
              <div className="flex justify-end gap-3 pt-2">
                <button
                  type="button"
                  onClick={onClose}
                  className="px-3 sm:px-5 py-2 sm:py-2.5 text-sm border border-gray-300 rounded-xl text-gray-700 hover:bg-gray-50 transition-colors font-medium"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleSend}
                  disabled={sending || !selectedEmployee || !message.trim() || (channel === 'email' && !subject.trim())}
                  className={`px-4 sm:px-6 py-2 sm:py-2.5 text-sm bg-gradient-to-r ${channelConfig.bg} text-white rounded-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed font-medium flex items-center gap-2 shadow-md`}
                >
                  {sending ? (
                    <>
                      <svg className="animate-spin h-3 w-3 sm:h-4 sm:w-4 text-white" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      <span className="hidden xs:inline">Sending...</span>
                      <span className="xs:hidden">...</span>
                    </>
                  ) : (
                    <>
                      <span className="text-sm sm:text-base">{channelConfig.icon}</span>
                      <span className="hidden xs:inline">Send {channelConfig.label}</span>
                      <span className="xs:hidden">Send</span>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Popup
        isOpen={popup.isOpen}
        type={popup.type}
        title={popup.title}
        message={popup.message}
        onClose={closePopup}
      />

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes zoomIn {
          from { transform: scale(0.95); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        .animate-in {
          animation-duration: 0.2s;
          animation-fill-mode: both;
        }
        .fade-in {
          animation-name: fadeIn;
        }
        .zoom-in {
          animation-name: zoomIn;
        }
        
        /* Custom breakpoint for extra small screens */
        @media (max-width: 480px) {
          .xs\\:inline {
            display: inline;
          }
          .xs\\:hidden {
            display: none;
          }
        }
        @media (min-width: 481px) {
          .xs\\:inline {
            display: inline;
          }
          .xs\\:hidden {
            display: inline;
          }
        }
      `}</style>
    </>
  );
}